import { jsx as _jsx } from "react/jsx-runtime";
import { Command } from "@air/cmdk";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const SearchCommandGroup = /*#__PURE__*/ memo((param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(Command.Group, {
        className: tailwindMerge("mb-3 flex shrink-0 flex-col gap-1 last:mb-0 only:mb-0 [&[hidden]]:hidden [&_[cmdk-group-heading]]:flex [&_[cmdk-group-heading]]:h-4 [&_[cmdk-group-heading]]:items-center [&_[cmdk-group-heading]]:px-1 [&_[cmdk-group-heading]]:text-10 [&_[cmdk-group-heading]]:font-bold [&_[cmdk-group-heading]]:uppercase [&_[cmdk-group-heading]]:tracking-[0.4px] [&_[cmdk-group-heading]]:text-grey-9", className),
        "data-testid": "SEARCH_COMMAND_GROUP",
        ...restOfProps
    });
});
SearchCommandGroup.displayName = "SearchCommandGroup";
